import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import authHeader from "services/auth-header";
import API from "services/axios";

export default function QuoteProductAdd({
  lastSortId,
  refreshFunc,
  showModal,
  selectedQuote,
}) {
  const dispatch = useDispatch();

  /*   All States
   ********************************************* */
  const [formData, setFormData] = useState({});

  const [loading, setLoading] = useState(false);

  let inputProperties = [
    { title: "Style No", name: "styleNo", type: "text" },
    { title: "Description", name: "description", type: "text" },
    { title: "Color", name: "color", type: "text" },
    { title: "Fabric", name: "fabric", type: "text" },
    { title: "Quantity", name: "quantity", type: "text" },
    { title: "Price", name: "price", type: "text" },
  ];

  /*   All Functions
   ********************************************* */
  const loadingOn = () => {
    setLoading(true);
  };
  const loadingOff = () => {
    setLoading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      loadingOn();

      let _formData = { ...formData };
      if (!_formData?.quantity) {
        _formData.quantity = 0;
      }
      if (!_formData?.price) {
        _formData.price = 0;
      }
      if (!_formData?.total) {
        _formData.total = 0;
      }

      let body = {
        ..._formData,
        quantity: parseInt(_formData?.quantity) || 0,
        price: Number(
          _formData?.quantity ? parseFloat(_formData?.price) : 0
        )?.toFixed(2),
        total: Number(_formData?.total) || 0,
        quoteId: selectedQuote?.id,
        sortId: lastSortId + 1,
      };

      const { data } = await API.post("/quote-product", body, {
        headers: authHeader(),
      });
      if (data?.type === "success") {
        await refreshFunc();
        showModal(false);
        loadingOff();
        return;
      }
      if (data?.type === "error") {
        dispatch(
          setNotification({
            message: data.message,
            type: "error",
          })
        );
      }
      console.log(data);
      loadingOff();
    } catch (err) {
      loadingOff();
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    }
  };

  const handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;

    setFormData((prev) => {
      return { ...prev, [name]: value };
    });
  };

  /*   All UseEffects
   ********************************************* */
  return (
    <div className="px-2 pb-2">
      {loading && <Spinner />}
      <h3>Add Product</h3>
      <hr className="mb-3 mt-1" />
      <form onSubmit={handleSubmit}>
        <div className="">
          {inputProperties?.map((item) => (
            <div key={item.name} className="mb-2">
              <label className="form-label" htmlFor={item?.name}>
                {item?.title?.toLocaleUpperCase()}
              </label>
              <input
                value={formData[item?.name]}
                name={item.name}
                placeholder={`Enter ${item.title}`}
                type={item?.type}
                step={
                  item?.name === "price" && item?.type === "number"
                    ? 0.01
                    : undefined
                }
                className="form-control"
                onChange={(e) => {
                  handleChange(e);
                }}
              />
            </div>
          ))}
          <div className="mb-2">
            <label className="form-label" htmlFor={"total"}>
              Total Amount
            </label>
            <input
              value={parseFloat(
                (formData?.quantity || 0) * (formData?.price || 0)
              ).toFixed(2)}
              readOnly
              disabled
              placeholder="Enter Price & Quantity"
              type={"text"}
              className="form-control"
            />
          </div>
        </div>

        <div className="text-end mt-3">
          <button
            type="button"
            onClick={() => {
              showModal(false);
            }}
            className="btn btn-secondary me-1"
          >
            Close
          </button>
          <button type="submit" disabled={loading} className="btn btn-primary">
            Add
          </button>
        </div>
      </form>
    </div>
  );
}
